import deepmerge from 'deepmerge';
import { isValidElement } from 'react';

/**
 * Shared deepmerge options for translation resolution.
 * Prevents deepmerge from recursively merging React elements and arrays —
 * brand-specific values replace defaults wholesale instead.
 */
export const deepmergeOptions: deepmerge.Options = {
  isMergeableObject: (value): value is object =>
    value !== null &&
    typeof value === 'object' &&
    !isValidElement(value) &&
    !Array.isArray(value),
};
